/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */
import { withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import {
    validationDefaultProps,
    validationPropTypes,
    withValidation,
} from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { AccountService } from 'gw-capability-gateway-policy';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import gatewayMessages from '../gateway.messages';
import messages from './NewQuoteAccountSearch.messages';
import metadata from './NewQuoteAccountSearch.metadata.json5';
import styles from './NewQuoteAccountSearch.module.scss';

const ACCOUNT_TYPE = {
    commercial: 'company',
    personal: 'person',
};

class NewQuoteAccountSearch extends Component {
    static contextType = TranslatorContext;

    state = {
        searchResult: false,
        submissionVM: {},
        existingSearchResult: [],
        showErrorContent: false,
        showNoMatch: false,
        showNoLengthMatch: false,
        showAccountMatches: false,
        showErrors: false
    };

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        ...validationPropTypes,
        ...validationDefaultProps,
    };

  

   

    componentDidMount() {
        let { submissionVM } = this.state;
        const { authUserData } = this.props;
        const localeService = ServiceManager.getService('locale-service');
        const model = {
            contactType: ACCOUNT_TYPE.personal,
            country: localeService.getDefaultCountryCode(),
            associationName_TWIA: _.get(authUserData, 'associationName_TWIA')
        };
        submissionVM = this.createVM(model);
        this.setState({
            submissionVM
        });
    };

    showValidations = value => {
        let showContent = false;
        if (value.contactType === 'person') {
            if (value.lastName.length < 5) {
                showContent = true;
            }
        }
        return showContent;
    };

    createVM = model => {
        const { viewModelService } = this.props;
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.account.search.dto.AccountSearchCriteriaDTO'
        );
    };

    writeValue = (value, path) => {
        const { submissionVM } = this.state;
        _.set(submissionVM, path, value);
        this.setState({ submissionVM });
    };

     // eslint-disable-next-line consistent-return
     searchAccounts = async () => {
        const { isComponentValid } = this.props;
        if(!isComponentValid) {
            this.setState({
                showErrors: true
            });
            return false
        }
        const { submissionVM } = this.state;
        const {
            submissionVM: { value },
        } = this.state;
        const { authHeader, modalContext } = this.props;
        let { searchResult, existingSearchResult } = this.state;
        let accounts = [];
        try {
            accounts = await AccountService.getPotentialExistingAccounts(
                submissionVM.value,
                authHeader
            );
            searchResult = true;
        } catch {
            modalContext
                .showAlert({
                    title: gatewayMessages.modalError,
                    message: gatewayMessages.gatewayViewsModalErrorData,
                    status: 'error',
                    icon: 'mi-error-outline',
                })
                .catch(_.noop);
        }
        existingSearchResult = this.getResponse(accounts);
        this.setState({
            searchResult,
            existingSearchResult,
        });
        if (existingSearchResult.length === 0) {
            if (value.contactType === 'company') {
                if (value.contactName.length < 5) {
                    this.setState({
                        showNoLengthMatch: true,
                        showErrorContent: false,
                        showNoMatch: false,
                        showAccountMatches: false,
                    });
                } else {
                    this.setState({
                        showNoMatch: true,
                        showErrorContent: false,
                        showNoLengthMatch: false,
                        showAccountMatches: false,
                    });
                }
            } else if (this.showValidations(value) === true) {
                this.setState({
                    showErrorContent: true,
                    showNoMatch: false,
                    showNoLengthMatch: false,
                    showAccountMatches: false,
                });
            } else {
                this.setState({
                    showNoMatch: true,
                    showErrorContent: false,
                    showNoLengthMatch: false,
                    showAccountMatches: false,
                });
            }
        } else {
            this.setState({
                showAccountMatches: true,
                showNoMatch: false,
                showNoLengthMatch: false,
                showErrorContent: false,
            });
        }
    };

    onSearchAgain = () => {
        let { searchResult } = this.state;
        searchResult = false;
        this.setState({
            searchResult,
        });
    };

    getCell = (item, index, { id: property }) => item[property];

    getResponse = searchResponse => {
        const translator = this.context;
        const userList = searchResponse.map(result => {
            const user = {
                startNewQuote: `${translator(messages.startNewQuote)}`,
                accountNumber: result.accountNumber,
                displayName: result.accountHolder.primaryAddress.displayName,
                contactName: result.accountHolder.displayName,
                canView: result.canUserView && result.canUserCreateSubmission,
            };

            return user;
        });
        return userList;
    };

    newCustomerBtnClick = () => {
        const { history } = this.props;
        const { submissionVM } = this.state;
        const nextLocation = {
            accountSearchCriteria: _.get(submissionVM, 'value'),
        };
        history.push('/new-quote', nextLocation);
    };

    startNewQuoteLink = (item, index, { id: property }) => {
        const value = item[property];
        const { submissionVM } = this.state;
        const { accountNumber } = item;
        // DE15694
        
            return (
                <Link
                    to={{
                        pathname: `/new-quote/${accountNumber}`,
                        state: {
                            accountSearchCriteria: submissionVM.value,
                        },
                    }}
                >
                    {value}
                </Link>
            );
    };

    handleNewQuoteCancel = () => {
        const { history } = this.props;
        history.push('/');
    };

    handleCancel = () => {
        const { modalContext } = this.props;
        modalContext
            .showConfirm({
                title: messages.cancelQuote,
                message: messages.cancelMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yes,
                cancelButtonText: commonMessages.noModel,
            })
            .then(results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                return this.handleNewQuoteCancel();
            }, _.noop);
    };

    render() {
        const {
            submissionVM,
            searchResult,
            existingSearchResult,
            showErrorContent,
            showNoMatch,
            showNoLengthMatch,
            showAccountMatches,
            showErrors
        } = this.state;
        const { setComponentValidation } = this.props;
        const translator = this.context;
        const accountType = _.get(submissionVM, `${'contactType'}.value.code`);
        const overrideProps = {
            '@field': {
                labelPosition: 'left',
            },
            accountTypeToggle: {
                value: accountType,
                visible: _.get(submissionVM, 'associationName_TWIA.value.code') === 'twia',
            },
            commercialContainer: {
                visible: accountType === ACCOUNT_TYPE.commercial,
            },
            personalContainer: {
                visible: accountType === ACCOUNT_TYPE.personal,
            },
            exisitingUserTable: {
                data: existingSearchResult,
            },
            newQuoteContainer: {
                visible: !searchResult,
            },
            existingSearchResult: {
                visible: searchResult,
            },
            noMatch: {
                visible: showNoMatch,
            },
            detailsaccount: {
                visible: showAccountMatches,
            },
            possibleBaseQuote: {
                visible: showAccountMatches,
            },
            noLengthMatch: {
                visible: showErrorContent,
            },
            noCompanyLengthMatch: {
                visible: showNoLengthMatch,
            },
            associationName: {
                value: translator({id: _.get(submissionVM, 'associationName_TWIA.value.name', '')})
            },
            tfpaAccountType: {
                visible: _.get(submissionVM, 'associationName_TWIA.value.code') === 'tfpa',
                value: translator(messages.individual)
            }
        };
        const resolvers = {
            resolveValue: this.readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                onSearchAccounts: this.searchAccounts,
                getCell: this.getCell,
                startNewQuoteLink: this.startNewQuoteLink,
                onSearchAgain: this.onSearchAgain,
                onCancel: this.handleCancel,
                newCustomerBtnClick: this.newCustomerBtnClick,
            },
        };

        const readValue = (id, path) => readViewModelValue(
                metadata.pageContent,
                submissionVM,
                id,
                path,
                overrideProps
            );

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                showErrors={showErrors}
                overrideProps={overrideProps}
                resolveValue={readValue}
                onValidationChange={setComponentValidation}
                onValueChange={this.writeValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }
}
export const NewQuoteAccountSearchComponent = withModalContext(
    NewQuoteAccountSearch
);
export default withRouter(
    withValidation(
        withViewModelService(
            withAuthenticationContext(withModalContext(NewQuoteAccountSearch))
        )
    )
);
